export const dataColumnFirst = [
  {
    title: "Home",
    link: "#home",
    className: "footer-link",
  },
  {
    title: "About",
    link: "#about",
    className: "footer-link",
  },
  {
    title: "Skills",
    link: "#skills",
    className: "footer-link",
  },
];

export const dataColumnSecond = [
  {
    title: "Projects",
    link: "#portfolio",
    className: "footer-link",
  },
  {
    title: "Contact",
    link: "#contact",
    className: "footer-link",
  },
];

export const followLinks = [
  {
    title: "Github",
    link: "https://github.com/manishhansal",
    className: "bx bxl-github",
  },
  {
    title: "LinkedIn",
    link: "https://www.linkedin.com/in/manish-kumar-939467210/",
    className: "bx bxl-linkedin",
  },
  {
    title: "Twitter",
    link: "https://twitter.com/ManishK62653031",
    className: "bx bxl-twitter",
  },
  {
    title: "Whatsapp",
    link: "https://wa.me/8581935284",
    className: "bx bxl-whatsapp",
  },
];

export const skills = [
  {
    title: "HTML5",
    className: "devicon-html5-plain",
  },
  {
    title: "CSS3",
    className: "devicon-css3-plain",
  },
  {
    title: "JavaScript",
    className: "devicon-javascript-plain",
  },
  {
    title: "React.js",
    className: "devicon-react-original",
  },
  {
    title: "Redux",
    className: "devicon-redux-original",
  },
  {
    title: "Material-UI",
    className: "devicon-materialui-plain",
  },
  {
    title: "Express.js",
    className: "devicon-express-original",
  },
  {
    title: "Node.js",
    className: "devicon-nodejs-plain",
  },
  {
    title: "mySQL",
    className: "devicon-mysql-plain",
  },
  {
    title: "mongoDB",
    className: "devicon-mongodb-plain",
  },
  {
    title: "socket.io",
    className: "devicon-socketio-plain",
  },
];

export const tools = [
  {
    title: "Git",
    className: "devicon-git-plain",
  },
  {
    title: "Github",
    className: "devicon-github-plain",
  },
  {
    title: "VS Code",
    className: "devicon-visualstudio-plain",
  },
  {
    title: "Heroku",
    className: "devicon-heroku-plain",
  },
  {
    title: "Figma",
    className: "devicon-figma-plain",
  },
];

export const projects = [
  {
    title: "askFundU.com",
    description:
      "Build a social web app for a startup company where people can post different types of posts related to stocks.",
    image: "fundu-image.png",
    githubLink: "https://github.com/fundu-games/fundu-social-frontend",
    liveLink: "https://www.askfundu.com/",
    techStack: [
      "React.js",
      "Redux.js",
      "Material UI",
      "Node.js",
      "Express.js",
      "MongoDB",
    ],
  },
  {
    title: "SpaceX Clone",
    description:
      "This is my personal project, built the landing page and capsules page of SpaceX website in 3 days.",
    image: "spacex-image.png",
    githubLink:
      "https://github.com/manishhansal/manish-kumar-frontend-developer",
    liveLink: "https://my-spacex-clone.vercel.app/",
    techStack: [
      "React.js",
      "Tailwind CSS",
      "Unit Testing",
      "React Testing Library",
    ],
  },

  {
    title: "Chat App",
    description:
      "This is my solo project, where a user can create account and start chatting with his/her friend or family, built-in 5 days. Basically, this is my MERN-stack project or full-stack project.",
    image: "my_chat_app.png",
    githubLink: "https://github.com/manishhansal/My_chat_app",
    liveLink: "https://my-mern-chatapp.netlify.app",
    techStack: ["React.js", "Node.js", "Express.js", "Socket.io", "MongoDB"],
  },
  {
    title: "Bookmyshow Clone",
    description:
      "BookMyShow clone where users can see movies, events, trailers etc. And also able to select cities, can login and also can book movies or events. A collaborative project, built in 5 days by a team of 3 developers and also won third prize.",
    image: "Bookmyshow1.png",
    githubLink: "https://github.com/vikalpvarshney1/team8",
    liveLink: "https://vikalpbookmyshow.netlify.app",
    techStack: ["React.js", "Redux.js", "Styled Components", "JSON Server"],
  },
  {
    title: "KFC Clone",
    description:
      "KFC clone where users can see different food items, can add items to cart and also can order. This is my first collaborative project, built in 5 days by a team of 3 developers.",
    image: "KFC1.png",
    githubLink: "https://github.com/Vishalrj750/Final_Kfc_Repo",
    liveLink: "https://jolly-hawking-c11904.netlify.app/",
    techStack: ["HTML5", "CSS3", "JavaScript"],
  },

  {
    title: "Tourmyindia Clone",
    description:
      "Clone of tourmyindia website, user can get detailed information on India tourism & travel guide. This is my first solo project after learning the basics of web development.",
    image: "Tourmyindia.png",
    githubLink: "https://github.com/manishhansal/Tour_my_india_clone",
    liveLink: "https://tourmyindiaclone.netlify.app",
    techStack: ["HTML5", "CSS3", "JavaScript"],
  },
  {
    title: "TicTacToe",
    description:
      "Simple tictactoe mini game where two players can play tictactoe. This is my solo project.",
    image: "Tictactoe.png",
    githubLink: "https://github.com/manishhansal/tictactoe",
    liveLink: "https://tictactoemadebyme.netlify.app/",
    techStack: ["HTML5", "CSS3", "JavaScript"],
  },
];

export const resumeLink =
  "https://drive.google.com/file/d/1OH66l2CyOGr8gD6ReOgyQnQkAFD4WQV5/view?usp=sharing";
